import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../api/client";
import ENDPOINTS from "../../api/endpoints";
import { showNotification } from "../Notifications/notificationsSlice";

export const verifyUser = createAsyncThunk(
  "auth/verifyUser",
  async (_, { rejectWithValue }) => {
    try {
      console.log("🔑 Calling backend to verify user...");

      // Token is automatically added by the API client interceptor
      const response = await apiClient.get(ENDPOINTS.AUTH.VERIFY);

      console.log("✅ Backend verification successful");
      return {
        ...response.data,
        loginMethod: "auth0",
      };
    } catch (error) {
      console.error("❌ verifyUser failed:", error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message
      );
    }
  }
);

export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, { rejectWithValue, extra }) => {
    try {
      const { auth0 } = extra;
      auth0.logout({
        logoutParams: { returnTo: window.location.origin },
      });
      return {};
    } catch {
      return rejectWithValue("Logout failed");
    }
  }
);

export const markTrainingVideoComplete = createAsyncThunk(
  "users/markTrainingVideoComplete",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiClient.patch(
        ENDPOINTS.USERS.MARK_TRAINING_VIDEO_COMPLETED
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchTrainingVideos = createAsyncThunk(
  "users/fetchTrainingVideos",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiClient.get(
        ENDPOINTS.USERS.FETCH_TRAINING_VIDEOS
      );

      console.log("Training videos response:", response.data);

      return response.data.data; // [{ id, filename, title, url }]
    } catch (error) {
      dispatch(
        showNotification({
          message: "Failed to load training videos",
          type: "error",
        })
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);